<div class="fixed-bottom bg-white d-block d-md-none mb-myaccount-nav-container">
  <div class="d-flex pt-2">
    <ul class="list-inline mx-auto justify-content-center">
      <li *ngFor="let item of navigationItems" class="list-inline-item">
        <a *ngIf="!item.isExternal" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="item.link" routerLinkActive #routerLink="routerLinkActive" class="mb-myaccount-nav-item-tab d-flex flex-column">
          <div>
            <img *ngIf="!routerLink.isActive" class="mx-auto d-block" height="24" width="24" alt="navigation-tab" title="navigation-tab" [src]="'assets/images/my-account/icons/' + item.icon">
            <img *ngIf="routerLink.isActive" class="mx-auto d-block" height="24" width="24" alt="navigation-tab" title="navigation-tab" [src]="'assets/images/my-account/icons/' + item.activeIcon">
          </div>
          <div>
            <span class="mb-myaccount-nav-link" [ngClass]="{'mb-myaccount-nav-tab-active' : routerLink.isActive}">{{ item.text | cxTranslate}}</span>
          </div>
        </a>
        <a *ngIf="item.isExternal" [href]="item.link" class="mb-myaccount-nav-item-tab d-flex flex-column">
          <div>
            <img class="mx-auto d-block" height="24" width="24" alt="navigation-tab" title="navigation-tab" [src]="'assets/images/my-account/icons/' + item.icon">
          </div>
          <div>
            <span class="mb-myaccount-nav-link">{{ item.text | cxTranslate}}</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
